// @ts-nocheck
import { Box, InputLabel } from "@mui/material";
import { CustomSwitch } from "../Custom/Switch";
import PropTypes from "prop-types";
import styles from "./other.module.css";
import { v4 as uuid } from "uuid";

export const BarToggle = ({
  message,
  onChange,
  value,
  slim = false,
  leftToggle = true,
  backgroundSx = {},
}) => {
  const id = uuid();
  return (
    <Box className={styles["auto-approve-container"]} sx={{ ...backgroundSx }}>
      {leftToggle && (
        <CustomSwitch
          id={id}
          slim={slim}
          onChange={(e) => {
            const val = e?.target?.checked;
            onChange(val);
          }}
          checked={value}
        />
      )}
      <InputLabel htmlFor={id}>{message}</InputLabel>
      {!leftToggle && (
        <CustomSwitch
          id={id}
          slim={slim}
          onChange={(e) => {
            const val = e?.target?.checked;
            onChange(val);
          }}
          checked={value}
        />
      )}
    </Box>
  );
};

BarToggle.propTypes = {
  message: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  slim: PropTypes.bool,
  leftToggle: PropTypes.bool,
  backgroundSx: PropTypes.object,
};